import { useEffect, useState } from 'react'
import { readUnterschriften, type UnterschriftDokument } from '../../api/unterschrift'
import type { Gespeichert } from './UnterschriftBox'

export function useUnterschriften(
  coachingId: string | null,
  dokument: UnterschriftDokument,
  name: string,
): Gespeichert | null {
  const [stand, setStand] = useState<Gespeichert | null>('laden')
  useEffect(() => {
    let cancelled = false
    setStand('laden')
    if (!coachingId) return
    readUnterschriften(coachingId, dokument)
      .then((gelesen) => {
        if (!cancelled) setStand(gelesen)
      })
      .catch((error: unknown) => {
        console.error(`${name} laden fehlgeschlagen:`, error)
        if (!cancelled) setStand('fehler')
      })
    return () => {
      cancelled = true
    }
  }, [coachingId, dokument, name])
  return stand
}
